module.exports = __webpack_public_path__ + "static/media/couple_in_front_of_house_2.81cefffc.jpg";